module.exports = __webpack_public_path__ + "img/btn-login.15101653.png";